// Chart chrome for the parts of recharts that only take a hex.
//
// The status ramp is *status*, not categorical — the NetComTV pack allows one
// accent and no rainbow of series hues; these three encode a state. Validated
// with the dataviz validator against the card surface (--pairs all): CVD
// separation dE 10.9 protan, normal-vision floor 17.1, all three above 3:1
// contrast. Do not substitute by eye. Kept in step with tailwind.config.js
// `state` and used by every chart, so the pages cannot drift apart.
export const BURN_COLOR = { ok: "#45b184", warn: "#f5821e", critical: "#c8433a" } as const;

export const CHART = {
  axis: "#8a93a6", // --muted
  grid: "#2a3149", // derived navy hairline
  surface: "#1b2236", // card ground
  ink: "#f2f5f9", // headings
  inkBody: "#c9d2e0", // --navy-ink
} as const;
